export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does Inka Glass serve?",
    a: "We're based in Houston, TX and serve the greater Houston area — including The Woodlands, Sugar Land, Pearland, Katy, Cypress, Spring, Conroe, Tomball, Humble, Kingwood, Atascocita, Rosenberg, and Magnolia.",
  },
  {
    q: "What services do you offer?",
    a: "We specialize in window replacement and glass replacement for homes and businesses. That includes energy-efficient replacement windows, broken and cracked pane replacement, foggy double-pane (insulated glass unit) replacement, storefront glass, shower doors, tabletops, and mirrors.",
  },
  {
    q: "How much does window or glass replacement cost?",
    a: "Pricing depends on the size, type, and quantity of glass or windows, plus any special glass like tempered or Low-E. We provide free, no-pressure written estimates so you know the price before any work begins.",
  },
  {
    q: "Can you fix foggy or cloudy double-pane windows?",
    a: "Yes. Foggy windows usually mean the seal on the insulated glass unit has failed and moisture is trapped between the panes. In most cases we can replace just the glass unit instead of the entire window, restoring clarity and efficiency for less.",
  },
  {
    q: "Do you replace glass for commercial properties?",
    a: "Absolutely. We handle storefront glass, commercial windows, and business glass replacement in addition to residential work. Tell us about your property and we'll recommend the right solution.",
  },
  {
    q: "How soon can you replace broken glass?",
    a: "We know broken glass is a security and safety concern, so we move quickly. Reach out with your measurements or send us photos and we'll get you scheduled as soon as possible.",
  },
  {
    q: "Are your replacement windows energy efficient?",
    a: "Yes. We offer double-pane, Low-E, and insulated glass options built for the Houston heat and humidity — helping cut cooling costs, reduce glare, and keep your home more comfortable year-round.",
  },
  {
    q: "What are your hours?",
    a: "We're open Monday to Friday 9 AM–5 PM and Saturday 9 AM–2 PM, closed Sunday. We're also online and responding to messages 24/7, so you can reach out any time.",
  },
];
